module.exports = __webpack_public_path__ + "img/mark.187e2544.jpg";